import { render, staticRenderFns } from "./published-appeals.vue?vue&type=template&id=473a91f2&scoped=true"
import script from "./published-appeals.vue?vue&type=script&lang=js"
export * from "./published-appeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a91f2",
  null
  
)

export default component.exports